import { render, staticRenderFns } from "./PriceBrandTab.vue?vue&type=template&id=3b173475&"
import script from "./PriceBrandTab.vue?vue&type=script&lang=js&"
export * from "./PriceBrandTab.vue?vue&type=script&lang=js&"
import style0 from "./PriceBrandTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports